import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography, CircularProgress } from '@mui/material';
import metaService from '../../../../services/metaService';
import { decrypt, encrypt } from '../../../../util/crypto';

const MetaTrackingConfig = ({ onTrackingConfigChange, page, form }) => {
  const [pixelId, setPixelId] = useState('');
  const [key, setKey] = useState(decrypt(page?.tokenKey) || '');
  const [keyApiConversion, setKeyApiConversion] = useState(decrypt(page?.tokenApiConversion) || '');  
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  // console.log('MetaTrackingConfig mounted with page:', page, 'and form:', form);

  const verifyPixelId = async () => {
    setError('');
    setLoading(true);

    if (!pixelId || !key) {
      setError('ID do Pixel e Token de Acesso são obrigatórios.');
      setLoading(false);
      return;
    }
    //  else {
    //   onTrackingConfigChange({ pixelId, accessToken: key });
    //   setSuccess('Pixel Informado.');
    //   setError(null);
    //   setLoading(false);
    //   return;
    // }
    try {
      const response = await metaService.checkPixelHealth(pixelId, key);
      // console.log('Pixel health response:', response);
      if (response.success) {
        onTrackingConfigChange({ pixelId, accessToken: key, tokenApiConversion: encrypt(keyApiConversion) });
        setSuccess('ID/Token é válido.');
        setError(null);
      } else {
        onTrackingConfigChange({ pixelId, accessToken: key, tokenApiConversion: encrypt(keyApiConversion) });
        setSuccess('ID/Token não é válido.');
        setError(null);
        setLoading(false);
        // setSuccess(null);
        // setError('Por favor, verifique seu ID do Pixel.');
      }
    } catch (err) {
      setError('Erro ao verificar a integridade do ID. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    verifyPixelId();
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h5" gutterBottom>
        Inserir ID do Pixel 
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Pixel ID"
          variant="outlined"
          fullWidth
          value={pixelId}
          onChange={(e) => setPixelId(e.target.value)}
          sx={{ mb: 2, mt: 2 }}
          disabled={loading}
        />
        <Typography variant="h5" gutterBottom>
          Inserir Token da API Conversão
        </Typography>

        <TextField
          label="Token"
          variant="outlined"
          fullWidth
          value={keyApiConversion}
          onChange={(e) => setKeyApiConversion(e.target.value)}
          sx={{ mb: 2, mt: 2 }}
          disabled={loading}
        />
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            sx={{ mt: 1, minWidth: 150 }}
          >
            {loading ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CircularProgress size={20} color="inherit" />
                Verificando...
              </Box>
            ) : (
              'Verificar ID/Token'
            )}
          </Button>
          {error && <Typography color="error">{error}</Typography>}
          {success && <Typography color="#5ABF21">{success}</Typography>}

        </Box>
      </form>
    </Box>
  );
};

export default MetaTrackingConfig;